<kilowant-header [isSeller]="true" linkHome="/seller/home/accepted-offers" [title]="title"></kilowant-header>
<div class="form seller" *ngIf="contract!=null">
    <div class="card">
        <div class="body">
            <div>
                <div class="body mt-10">
                    <div class="account-info-block">
                        <p class="card-block-background">
                            TRANSACTION SUMMARY
                        </p>
                        <div>
                            <p class="accountInfoBorder">Utility</p>
                            <p class="subUniqueTitle">{{contract.detailsUtility || '-'}}</p>
                            <p class="accountInfoBorder">Load Zone</p>
                            <p class="subUniqueTitle">{{contract.detailsLoadZone || '-'}}</p>
                            <p class="accountInfoBorder">Rate Class</p>
                            <p class="subUniqueTitle">{{contract.detailsRateClass || '-'}}</p>
                            <p class="accountInfoBorder">Account Number(s)</p>
                            <p class="subUniqueTitle">{{getAccountNumbers(contract.accounts)}}</p>
                            <p class="accountInfoBorder">Product Type</p>
                            <p class="subUniqueTitle">{{contract.detailsProductType || '-'}}</p>
                            <p class="accountInfoBorder">Price</p>
                            <p class="subUniqueTitle">{{contract.getSalesPrice() | currency:'USD':'symbol':'1.5-5'}}/kWh</p>
                            <p class="accountInfoBorder">Service Start</p>
                            <p class="subUniqueTitle">1st meter read on or after {{contract.termFrom | date:'shortDate'}}</p>
                            <p class="accountInfoBorder">Service End</p>
                            <p class="subUniqueTitle">1st meter read on or after {{contract.termTo | date:'shortDate'}}</p>
                        </div>
                    </div>
                    <div class="account-info-block">
                        <p class="card-block-background">
                            BUYER
                        </p>
                        <div>
                            <p class="accountInfoBorder">First Name</p>
                            <p class="subUniqueTitle">{{contract.detailsBuyerFirstName || '-'}}</p>
                            <p class="accountInfoBorder">Last Name</p>
                            <p class="subUniqueTitle">{{contract.detailsBuyerLastName || '-'}}</p>
                            <p class="accountInfoBorder">Company Name</p>
                            <p class="subUniqueTitle">{{contract.detailsBuyerCompanyName || '-'}}</p>
                            <p class="accountInfoBorder">Address Line 1</p>
                            <p class="subUniqueTitle">{{contract.detailsBuyerAddressLine1 || '-'}}</p>
                            <p class="accountInfoBorder">Address Line 2</p>
                            <p class="subUniqueTitle">{{contract.detailsBuyerAddressLine2 || '-'}}</p>
                            <p class="accountInfoBorder">City</p>
                            <p class="subUniqueTitle">{{contract.detailsBuyerCity || '-'}}</p>
                            <p class="accountInfoBorder">State</p>
                            <p class="subUniqueTitle">{{(contract.detailsBuyerState!=null)?contract.detailsBuyerState.name:'-'}}</p>
                            <p class="accountInfoBorder">Zip</p>
                            <p class="subUniqueTitle">{{contract.detailsBuyerZip || '-'}}</p>
                            <p class="accountInfoBorder">Telephone</p>
                            <p class="subUniqueTitle">{{contract.detailsBuyerPhone || '-'}}</p>
                            <p class="accountInfoBorder">E-mail</p>
                            <p class="subUniqueTitle">{{contract.detailsBuyerEmail || '-'}}</p>
                            @if (contract.detailsBuyerTaxExempt) {
                            <div>
                                <p class="accountInfoBorder">Tax Exempt</p>
                                <p class="subUniqueTitle">Yes</p>
                                <p class="accountInfoBorder">Federal Tax ID</p>
                                <p class="subUniqueTitle">{{contract.detailsBuyerFederalTaxID || '-'}}</p>
                            </div>
                            }
                        </div>
                    </div>
                    <div class="account-info-block">
                        <p class="card-block-background">
                            SELLER
                        </p>
                        <div>
                            <p class="accountInfoBorder">First Name</p>
                            <p class="subUniqueTitle">{{contract.detailsSellerFirstName || '-'}}</p>
                            <p class="accountInfoBorder">Last Name</p>
                            <p class="subUniqueTitle">{{contract.detailsSellerLastName || '-'}}</p>
                            <p class="accountInfoBorder">Company Name</p>
                            <p class="subUniqueTitle">{{contract.detailsSellerCompanyName || '-'}}</p>
                            <p class="accountInfoBorder">Address Line 1</p>
                            <p class="subUniqueTitle">{{contract.detailsSellerAddressLine1 || '-'}}</p>
                            <p class="accountInfoBorder">Address Line 2</p>
                            <p class="subUniqueTitle">{{contract.detailsSellerAddressLine2 || '-'}}</p>
                            <p class="accountInfoBorder">City</p>
                            <p class="subUniqueTitle">{{contract.detailsSellerCity || '-'}}</p>
                            <p class="accountInfoBorder">State</p>
                            <p class="subUniqueTitle">{{(contract.detailsSellerState!=null)?contract.detailsSellerState.name:'-'}}</p>
                            <p class="accountInfoBorder">Zip</p>
                            <p class="subUniqueTitle">{{contract.detailsSellerZip || '-'}}</p>
                            <p class="accountInfoBorder">Telephone</p>
                            <p class="subUniqueTitle">{{contract.detailsSellerPhone || '-'}}</p>
                            <p class="accountInfoBorder">E-mail</p>
                            <p class="subUniqueTitle">{{contract.detailsSellerEmail || '-'}}</p>
                        </div>
                    </div>
                    @if (contract.termsDocument!=null || (contract.terms!=null && contract.terms.length>0)) {
                    <div class="account-info-block">
                        <p class="card-block-background" [class]="(viewTerms)?'':'view-closed'">
                            TERMS &amp; CONDITIONS
                            <a [class]="(viewTerms)?'collapse':'open'" (click)="viewTerms=!viewTerms"></a>
                        </p>
                        <div [class]="(viewTerms)?'visible':'hidden'">
                            <div class="p-10 f13">
                                <b>Both Buyer and Seller agree to the above transaction governed by the Terms &amp; Conditions: </b><br /><br />
                                @if (contract.termsDocument!=null) {
                                <div><a><b>Download</b></a></div>
                                }
                                @if (contract.terms!=null && contract.terms.length>0) {
                                <div class="f13 long-text-cut text-nowarp">
                                    <b>HASH:</b> {{contract.termsHash}}
                                </div>
                                }
                                @if (contract) {
                                <div class="f13" [innerHTML]="contract.terms"></div>
                                }
                            </div>
                        </div>
                    </div>
                    }
                    @if (contract.isCancelled()) {
                    <div class="mt-10">
                        @if (contract.cancelledByBuyer || contract.cancelledBySeller) {
                        <p class="mb-10"><b>This price plan was cancelled {{cancelledBy(contract)}}</b></p>
                        }
                        @if (!contract.cancelledByBuyer && !contract.cancelledBySeller) {
                        <p class="mb-10"><b>This price plan was not confirmed</b></p>
                        }
                    </div>
                    }
                    <div class="mt-10 table-view">
                        <div class="cell">
                            <div class="font13">By Buyer: {{contract.buyerSignedUserEmail || '-'}}</div>
                            <div class="font13">on {{contract.confirmedByBuyerDate | date:'short'}} EST</div>
                            <div class="font13">IP: {{contract.buyerSignedIP || '-'}}</div>
                        </div>
                        <div class="cell">
                            <div class="font13">By Seller: {{contract.confirmedSellerUser.email}}</div>
                            <div class="font13">on {{contract.confirmedDate | date:'short'}} EST</div>
                            <div class="font13">IP: {{contract.sellerSignedIP || '-'}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
